/* global ga */

import 'autotrack/lib/plugins/clean-url-tracker';
import 'autotrack/lib/plugins/event-tracker';
import 'autotrack/lib/plugins/outbound-link-tracker';
import 'autotrack/lib/plugins/page-visibility-tracker';

ga('require', 'cleanUrlTracker', {
  indexFilename: 'index.html',
  queryDimensionIndex: 1,
  stripQuery: true,
  trailingSlash: 'add'
});

ga('require', 'eventTracker');

ga('require', 'outboundLinkTracker');

// ga('require', 'pageVisibilityTracker', {
//   fieldsObj: {
//     nonInteraction: null
//   }
// });



// WEBPACK FOOTER //
// ./utils/trackers.js